import { TEST_ID } from '../DataGridRow/constants';
import styles from '../DataGridRow/styles.module.scss';

import Grid from 'components/Grid';

import type { FunctionComponent, Props } from './types';

const DataGridRowWrapper: FunctionComponent<Props> = ({
    children,
    ref,
    style,
    testId = TEST_ID
}) => (
    <Grid className={styles.dataGridRow} ref={ref} style={style} testId={testId}>
        {children}
    </Grid>
);

export default DataGridRowWrapper;
